import { Environment, EnvironmentUrls, HttpResponse } from '../interfaces';
import { initAmazonAwsApi } from './amazonaws.api';
import { API_KEY_HEADER } from './api.constants';
import { ApiInstanceConfiguration } from './api.interfaces';
import { init as initMetadataApi } from './metadata.api';
import { setEnvironment } from './microservice.factory';
import { init as initApi } from './services.api';

/** Retrieve the API key from its header on an API response. */
export function getApiKeyFromResponse(response: HttpResponse) {
  if ('headers' in response) {
    return response?.headers?.[API_KEY_HEADER.toLowerCase()]?.toString() || '';
  }
  return '';
}

/** Return API URLs for the given environment. */
export const getEnvironmentUrls = ({
  value: environment = ''
}: Environment): EnvironmentUrls => {
  let metadata = '';
  let services = '';
  let hostedContentUrl = '';

  // TODO: Should this be "ascendon.tv" for PRD?
  if (environment.startsWith('prd')) {
    metadata = `https://metadata.${environment}.contentdirect.tv`;
    services = `https://services.${environment}.contentdirect.tv`;
  } else if (
    environment.startsWith('int') ||
    environment.startsWith('mig') ||
    environment.startsWith('ops') ||
    environment.startsWith('sbx') ||
    environment.startsWith('sls') ||
    environment.startsWith('stg') ||
    environment.startsWith('tig')
  ) {
    metadata = `https://metadata.${environment}.cdops.net`;
    services = `https://services.${environment}.cdops.net`;
  } else if (environment === 'local') {
    metadata = 'https://metadata.cdtv.lab';
    services = 'https://services.cdtv.lab';
  } else if (environment === 'localPS') {
    metadata = 'https://metadata.cdtv.lab:7201';
    services = 'https://services.cdtv.lab:7201';
  } else if (environment) {
    metadata = `https://${environment}.metadata.ascendon.tv`;
    services = `https://${environment}.services.ascendon.tv`;
  }

  hostedContentUrl = `https://content.invision.${environment}.ascendon.tv`;

  return {
    metadata,
    microservices: {},
    services,
    hostedContentUrl
  };
};

/** Configure the API "services" required by the application. */
export function ConfigureServices(config: ApiInstanceConfiguration) {
  setEnvironment(config);
  const environmentUrls = getEnvironmentUrls(config.environment);
  const mergedConfig = {
    ...config,
    environmentUrls
  };

  initApi(mergedConfig);

  initMetadataApi(mergedConfig);

  initAmazonAwsApi();
}
